<div class="card-header" [id]="headerId">
  <div
    *ngIf="headerText; else projectedContent"
    [ngClass]="headerClass"
    data-testid="card-header-text"
  >
    {{ headerText | translate }} {{ headerTextSuffix }}
  </div>
  <ng-template #projectedContent>
    <div [ngClass]="headerClass">
      <ng-content></ng-content>
    </div>
  </ng-template>
  <app-help-icon
    *ngIf="showHelpIcon"
    [helpPageName]="helpPageName"
    [ngClass]="helpIconClass"
  ></app-help-icon>
</div>
